import request from '../../../util/SuperagentUtils'
import {Account} from "../../../types/Account";


export const requestLogBackInAsAdmin = (onSuccess?: (user: Account) => void,
                                        onFail?: (err: any) => void) => {
  const result = request
    .post('/api/login-back-in-as-admin')

  if (onSuccess && onFail) {
    result
      .then((resp) => onSuccess(resp.body))
      .catch((err) => onFail(err))
  } else {
    return result
  }
}
